<template>
  <div class="enter-room">
    <!-- Form de entrada no centro -->
    <b-form v-if="!nameSet" @submit.prevent="enterRoom" class="enter-form">
      <b-form-group label="Digite seu nome" label-for="participantName">
        <b-form-input
          id="participantName"
          v-model="participantName"
          placeholder="Seu nome"
          required
        />
      </b-form-group>

      <b-button type="submit" variant="primary" :disabled="!participantName" block>
        Entrar na consulta
      </b-button>
    </b-form>

    <!-- MeetRoom -->
    <MeetRoom
      v-else
      :participant-name="participantName"
      :room-id="roomId"
      @leave="handleLeave"
    />

    <!-- Logo, muda de posição dependendo da tela -->
    <div
      class="logo-position"
      :class="nameSet ? 'top-left' : 'bottom-center'"
    >
      <small v-if="!nameSet" class="d-block mb-1">Product by</small>
      <img
        src="@/assets/logo.png"
        alt="Logomarca"
        fluid
        style="height: 30px;"
      />
    </div>
  </div>
</template>

<script>
import MeetRoom from './MeetRoom.vue'

export default {
  components: { MeetRoom },
  data() {
    return {
      participantName: '',
      nameSet: false,
      leftRoom: false,
      roomId: 'consulta-123' // sala fixa
    }
  },
  methods: {
    enterRoom() {
      this.nameSet = true
      this.leftRoom = false
    },
    handleLeave() {
      this.leftRoom = true
      this.nameSet = false
    },
    resetRoom() {
      this.participantName = ''
      this.nameSet = false
      this.leftRoom = false
    }
  }
}
</script>

<style scoped>
.enter-room {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center; /* mantém o form no centro vertical */
  align-items: center;
  position: relative;
}

/* Form centralizado */
.enter-form {
  width: 300px;
}

/* Logo com posições dinâmicas */
.logo-position {
  position: absolute;
  text-align: center;
  opacity: 0.8;
  transition: all 0.3s ease; /* animação suave na troca de posição */
}

/* Rodapé centralizado */
.bottom-center {
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

/* Canto superior esquerdo */
.top-left {
  top: 10px;
  left: 10px;
  transform: none;
  text-align: left;
}

.logo-position small {
  font-size: 0.75rem;
  color: #555;
}

.logo-position b-img {
  display: block;
  margin: 0 auto;
}
</style>
